import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { setRldCurrentView } from '../../actions/rldToolActions';
import { RLD_VIEW_LIBRARY } from './RldConstant';
import RldAccount from './RldAccount';
import RldToolTransferrableList from './RldToolTransferrableList';
import RldStudySelector from './RldStudySelector';
import { useSelector, useDispatch } from '../common/react-redux-hooks';
import RldExportFileFormat from './RldExportFileFormat';
import RldDictionaryFileFormat from './RldDictionaryFileFormat';
import RldFileStructureFormat from './RldFileStructureFormat';
import RldEmail from './RldEmail';
import RldGenerateButton from './RldGenerateButton';
import RldDictionaryOnly from './RldDictionaryOnly';
import RldAllLocalMarkets from './RldAllLocalMarkets';
import RldLibraryList from './RldLibraryList/RldLibraryList';
import GenericButton from '../common/GenericButton';
import {
  RldLibraryNewRequestLink,
  RldLibraryLinkWrapper,
} from './RldLibraryList/styledComponents';

const useStyles = makeStyles(theme => {
  return {
    root: {
      display: 'flex',
      padding: theme.spacing(3),
    },
  };
});

const RldToolLanding = () => {
  const { currentAccountId, uid } = useSelector(
    state => state.login.loginResponse.data
  );
  const { currentView } = useSelector(state => state.rldTool);
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleListClick = () => {
    dispatch(setRldCurrentView(RLD_VIEW_LIBRARY));
  };

  if (currentView === RLD_VIEW_LIBRARY) {
    return <RldLibraryList />;
  }

  return (
    <Grid container className={classes.root}>
      <Grid container item md={12}>
        <Grid item md={9}>
          <RldAccount userAccountID={currentAccountId} />
        </Grid>
        <Grid item md={3}>
          <RldLibraryLinkWrapper>
            <div className="button-group multi-select-button-group">
              <GenericButton
                name=" "
                btnStyle="button btn-library btn-priaryDisable"
                onBtnClick={handleListClick}
              />
            </div>
            <RldLibraryNewRequestLink onClick={handleListClick}>
              Library
            </RldLibraryNewRequestLink>
          </RldLibraryLinkWrapper>
        </Grid>
      </Grid>
      <Grid item md={12}>
        <RldStudySelector uid={uid} />
      </Grid>
      <Grid container>
        <Grid item md={9}>
          <RldToolTransferrableList uid={uid} />
        </Grid>
        <Grid item md={3}>
          <Grid>
            <RldExportFileFormat></RldExportFileFormat>
          </Grid>
          <Grid>
            <RldFileStructureFormat />
          </Grid>
          <Grid>
            <RldDictionaryFileFormat></RldDictionaryFileFormat>
          </Grid>
          <Grid>
            <RldEmail></RldEmail>
          </Grid>
          <Grid>
            <RldAllLocalMarkets />
          </Grid>
          <Grid>
            <RldDictionaryOnly />
          </Grid>
          <Grid>
            <RldGenerateButton uid={uid} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RldToolLanding;
